import { forWeb } from './assetUrlHelpers';
import { LoadedShape } from 'ff-canvas';

export const loadShape = async (url: string) => {

    const response = await fetch(forWeb(url, {w: 1000, h: 1000}), {
        mode: 'cors',
        headers: {
            'Accept': 'application/vnd+idt.shape+json'
        }
    });

    if (response.ok) {
        return await response.json() as LoadedShape;
    } else {
        throw new Error(`Shape load error: ${url} [${response.status}]`);
    }
};